import { render, staticRenderFns } from "./WasteVisualization.vue?vue&type=template&id=161fd48f&scoped=true&"
import script from "./WasteVisualization.vue?vue&type=script&lang=js&"
export * from "./WasteVisualization.vue?vue&type=script&lang=js&"
import style0 from "./WasteVisualization.vue?vue&type=style&index=0&id=161fd48f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161fd48f",
  null
  
)

export default component.exports